const INTERIOR = "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?auto=format&fit=crop&w=1400&q=80";

const STEPS = [
  { n: "01", t: "Écoute", d: "Nous échangeons sur votre projet, votre budget et vos attentes." },
  { n: "02", t: "Sélection", d: "Nous vous présentons les programmes et biens adaptés, plans à l'appui." },
  { n: "03", t: "Visite", d: "Visite du bien ou du chantier, sur place ou à distance." },
  { n: "04", t: "Accompagnement", d: "Réservation, suivi de construction et remise des clés." },
];

export const Process = () => (
  <section className="max-w-7xl mx-auto px-5 lg:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-14 items-center" data-testid="process-section">
    <div className="lg:col-span-6 order-2 lg:order-1">
      <p className="eyebrow">Notre démarche</p>
      <h2 className="font-display text-4xl lg:text-5xl mt-4 max-w-lg">Un accompagnement clair, à chaque étape</h2>
      <div className="mt-12 space-y-8">
        {STEPS.map((s) => (
          <div key={s.n} className="flex gap-6 border-b border-[#2F2A28]/10 pb-8 last:border-0">
            <span className="font-display text-3xl text-[#C88A58]">{s.n}</span>
            <div>
              <h3 className="font-display text-2xl">{s.t}</h3>
              <p className="text-[#756D69] text-sm mt-1">{s.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="lg:col-span-6 order-1 lg:order-2 aspect-[4/5] overflow-hidden rounded-sm">
      <img src={INTERIOR} alt="Intérieur résidence" className="h-full w-full object-cover" />
    </div>
  </section>
);
